'use strict';

const debounce = require('lodash/debounce');
const endpoint = $('.suggestions-wrapper').data('url');
const UP_KEY = 38;
const DOWN_KEY = 40;
const DIRECTION_DOWN = 1;
const DIRECTION_UP = -1;
const $body = $('body');

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).siblings('.suggestions-wrapper');
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    if (!$('.modal:not(.suggestions).show').length) {
        $body.removeClass('modal-open');
    }
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $('input.search-field').val('');
    clearModals();
    $('.search-mobile .suggestions').unbind('scroll');
    $('.suggestions-wrapper').empty();
    $('.site-search .reset-button').removeClass('d-block');
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    const mobileSearchIcon = '.search-mobile button.';
    const iconSearch = 'fa-search';
    const iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch)
            .removeClass(iconSearch)
            .addClass(iconSearchClose)
            .attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose)
            .removeClass(iconSearchClose)
            .addClass(iconSearch)
            .attr('type', 'submit');
    }
}

/**
 * Positions Suggestions panel on page
 */
function positionSuggestions() {
    const $window = $(window);
    const windowHeight = $window.outerHeight();
    let topOffset = $('.header-wrapper').outerHeight();
    const $suggestions = $('.suggestions');
    $suggestions.css({ top: topOffset, height: windowHeight - topOffset });
    $suggestions.toggle($('.suggestion-list').children().length > 0);
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    const $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    if (typeof response !== 'object') {
        $suggestionsWrapper.append(response).show();
        const productCount = $('.suggestions').data('product-count');
        $('.searchflyout-result-count').text(productCount);
        $('.searchflyout-result-wrapper').toggleClass('d-none', $('.passive-suggestion').length > 0);
        $('body').addClass('no-scroll');
        $('nav').addClass('active');
        $(this).siblings('.reset-button').addClass('d-block');
        positionSuggestions($('.search-mobile'));

        if (!app.isDesktop()) {
            toggleSuggestionsIcon('close');
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        const suggestionsList = $('.suggestions .item');
        if (suggestionsList.length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
        $(document).trigger('wishlist:check');
    } else {
        $suggestionsWrapper.hide();
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    const $scope = $(scope);

    if ($scope.val().length >= 0) {
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($scope.val()),
            method: 'GET',
            success: processResponse,
        });
    } else {
        toggleSuggestionsIcon('search');
        $scope.siblings('.reset-button').removeClass('d-block');
        clearModals();
        getSuggestionsWrapper(scope).empty();
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    const suggestionsList = $('.suggestions .item');

    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            const idx = index + direction;
            const $this = $(this);
            if ($this.hasClass('selected')) {
                $this.removeClass('selected');
                $this.removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $this.removeProp('aria-selected');
                    $('input.search-field').each(function () {
                        $this.attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected').attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $this.attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

module.exports = function () {
    $('form[name="simpleSearch"]').on('submit', function (e) {
        const suggestionsList = $('.suggestions .item');
        const suggestionListSelected = suggestionsList.filter('.selected');
        if (suggestionListSelected.length !== 0) {
            e.preventDefault();
            suggestionListSelected.find('a')[0].click();
        }
    });

    $('input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        const debounceSuggestions = debounce(getSuggestions, 300);
        const $this = $(this);
        $this.on('input focus', function (e) {
            // Capture Down/Up Arrow Key Events
            const term = $(this).val();
            const minChar = parseInt($('.suggestions').data('min-char'), 10) || 3;
            const hasPassiveSuggestion = $('.passive-suggestion').length > 0;
            if (!((hasPassiveSuggestion && term.length < minChar) || (e.type === 'focus' && term.length >= minChar))) {
                switch (e.which) {
                    case DOWN_KEY:
                        handleArrow(DIRECTION_DOWN);
                        e.preventDefault(); // prevent moving the cursor
                        break;
                    case UP_KEY:
                        handleArrow(DIRECTION_UP);
                        e.preventDefault(); // prevent moving the cursor
                        break;
                    default:
                        debounceSuggestions(this, e);
                }
            }
        });

        $this.on('keydown', function (e) {
            if (e.which === 27) {
                $(this).closest('.search-form').find('.reset-button').click();
            }
        });

        $this
            .on('focus', function () {
                const $innterthis = $(this);
                $innterthis.attr('placeholder', '');
            })
            .on('blur', function () {
                const $innterthis = $(this);
                $innterthis.attr('placeholder', $innterthis.data('placeholder'));
            });
    });

    $body.on('click', function (e) {
        const $target = $(e.target);

        if ($target.parents('.search-mobile').length && $target.is('.reset-button')) {
            $('.suggestions-wrapper').html('');
            $('nav').removeClass('active expand-input-field');
            $(this).removeClass('no-scroll');
            tearDownSuggestions();
            $('.search-mobile').addClass('d-lg-none');
        }
    });

    $body.on('click touchend', '.search-mobile button.fa-close', function (e) {
        e.preventDefault();
        $('.suggestions').hide();
        toggleSuggestionsIcon('search');
        tearDownSuggestions();
    });

    $('.site-search .reset-button').on('click', function () {
        $(this).removeClass('d-block');
        $('.searchflyout-result-wrapper').addClass('d-none');
    });
};
